import { SvgIcon, SvgIconProps } from '@mui/material';

const DownloadFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="DownloadFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M5 21H19V19H5V21ZM19 10H15V3H9V10H5L12 17L19 10Z" />
    </SvgIcon>
  );
};

export default DownloadFilled;
